export default "__VITE_ASSET__LkzzS_RS__"